import { map, Observable } from 'rxjs';

// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { DownloadPdfLibroGiornaleDto, StampeCepDto } from '@ideapa/common-dto';

import { DownloadType } from '@ideapa/common-utils';
import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class StampeCepApiClient extends BaseCRUDApiClient<StampeCepDto> {
  baseUrl = this.config.apiEndpoint + '/stampe-cep';

  constructor(
    http: HttpClient,
    private config: ApiClientConfig,
  ) {
    super(http);
  }

  downloadProspettoCep(
    idProspetto: number,
    includiAP: boolean,
    statoIniziale: boolean,
    downloadType: string,
    fileName: string,
  ): Observable<ArrayBuffer> {
    return this.http
      .post(
        this.baseUrl + '/download-prospetto-cep',

        {
          idProspetto: idProspetto,
          includiAP: includiAP,
          statoIniziale: statoIniziale,
          downloadType:
            downloadType == 'docx' ? DownloadType.Word : DownloadType.Pdf,
          fileName: fileName,
        },
        {
          responseType: 'arraybuffer',
        },
      )
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        }),
      );
  }

  downloadCostiPerMissioneCep(
    fileName: string,
    downloadType: string,
  ): Observable<ArrayBuffer> {
    return this.http
      .post(
        this.baseUrl + '/download-costi-per-missione',
        {
          fileName: fileName,
          downloadType,
        },
        {
          responseType: 'arraybuffer',
        },
      )
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        }),
      );
  }

  downloadLibroGiornaleCep() {
    return this.http.get<DownloadPdfLibroGiornaleDto | undefined>(
      this.baseUrl + '/download-libro-giornale',
    );
  }

  downloadPdfNotaIntegrativaCep(fileName: string): Observable<ArrayBuffer> {
    return this.http
      .post(
        this.baseUrl + '/download-pdf-nota-integrativa',
        {
          fileName: fileName,
        },
        {
          responseType: 'arraybuffer',
        },
      )
      .pipe(
        map((file: ArrayBuffer) => {
          return file;
        }),
      );
  }
}
